import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface PillarPageSubHeaderPropType {
  count: number;
  title: string;
}

const PillarPageSubHeader = (props: PillarPageSubHeaderPropType) => {
  const { count, title } = props;
  return (
    <div
      className={ivclass(
        'iv-text-grey-85',
        'iv-text-heading-2xl md:iv-text-heading-m sm:iv-text-[36px]',
        'iv-font-extrabold',
      )}
    >{`${count} ${title}`}</div>
  );
};

export default PillarPageSubHeader;
